import CardOverlay from './CardOverlay';
import { CostLabel } from './Amount';
import { IsMobile, useHover } from '../utils/Mobile';
const { useRef } = require('react');
const { GetCardColor, GetOpposedTextColor } = require('./Utilities/Utilities');
const { ShownName } = require('@tta/engine/Utilities/ShownNames');

// highlighted: outlined to show it can be put back (e.g. taken from the card row this turn)
// Cost: what using it costs (with static buttons, a card in hand), at its right, faded unless Usable; Note: said under
// the card in its hover (why it can't be used)
const CollapsedCard = ({ card, onClick, highlighted = false, title, Cost, Usable = false, Note }) => {
    const [showOverlay, setShowOverlay, hoverProps] = useHover();
    const componentRef = useRef(null);
    
    const cardColor = GetCardColor(card)
    const textColor = GetOpposedTextColor(card)

    const divStyle = {
        backgroundColor: cardColor,
        position: 'relative',
        boxShadow: '4px 4px 8px rgba(0, 0, 0, 0.5)',
        fontFamily:'Arial, Sans Serif',
        fontSize: '11px',
        color:textColor,
        padding: '0px 10px 0px 7px',
        borderRadius: '6px',
        minWidth: '110px',
        cursor: onClick ? 'pointer' : 'default',
        outline: highlighted ? '2px dashed #1a73e8' : 'none',
        // (on one line, the cost at its right: the hand is as wide as its widest card)
        ...(Cost ? { display: 'flex', alignItems: 'center', gap: '6px', whiteSpace: 'nowrap' } : {}),
    }

    if (card === undefined || card === null)
    {
        return (<div>mistakes were made</div>)
    }

    return (
        <div>
            <div 
                border="0px"
                style={divStyle}
                ref = {componentRef}
                onClick = {onClick}
                title = {title}
                {...hoverProps}
            >
                {card.age.substring(4)} - {ShownName(card.name)}{card.tacticBonus > 0 && ` +${card.tacticBonus}`}
                {Cost && <span className={`tta-hand-cost${Usable ? '' : ' off'}`}><CostLabel cost={Cost}/></span>}
            </div>
            <CardOverlay
                ShowOverlay={showOverlay}
                ComponentRef={componentRef}
                card={card}
                callback={() => {}} //don't want to keep the overlay up
                OnClose={() => setShowOverlay(false)}
                // (on a phone a tap shows the card: putting it back is done from there)
                Action={IsMobile && onClick ? { label: 'Put back', onClick } : undefined}
                Note={Note ?? title}
            />
        </div>
  );
};

export default CollapsedCard;